import type { Components, Theme } from '@mui/material/styles'

export const dialogTheme: Components<Theme> = {
    MuiDialogTitle: {
        styleOverrides: {
            root: ({ theme }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(4),
                paddingTop: theme.spacing(2),
                paddingBottom: theme.spacing(2),
                paddingLeft: theme.spacing(4),
                paddingRight: theme.spacing(4),
            }),
        },
    },
    MuiDialogContent: {
        styleOverrides: {
            root: ({ theme }) => ({
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing(4),
                paddingTop: theme.spacing(2),
                paddingBottom: theme.spacing(2),
                paddingLeft: theme.spacing(4),
                paddingRight: theme.spacing(4),
            }),
        },
    },
    MuiDialogContentText: {
        styleOverrides: {
            root: ({ theme }) => ({
                color: theme.palette.text.primary,
            }),
        },
    },
    MuiDialogActions: {
        styleOverrides: {
            root: ({ theme }) => ({
                paddingLeft: theme.spacing(4),
                paddingRight: theme.spacing(4),
                paddingTop: theme.spacing(2),
                paddingBottom: theme.spacing(2),
                gap: theme.spacing(4),
            }),
        },
    },
}
